// Private (friends) leagues.
import { httpsCallable } from 'firebase/functions';
import type { MiniLeague } from '@h2h/shared';
import { functions } from '../firebase';

export interface CreateMiniLeagueInput {
  leagueId: string;
  name: string;
  icon?: string;
  color?: string;
  settings?: { roundReminders?: boolean };
}

export async function createMiniLeague(input: CreateMiniLeagueInput): Promise<{ ok: true; miniLeague: MiniLeague }> {
  const call = httpsCallable<CreateMiniLeagueInput, { ok: true; miniLeague: MiniLeague }>(
    functions,
    'createMiniLeague'
  );
  return (await call(input)).data;
}

export async function joinMiniLeague(inviteCode: string): Promise<{ ok: true; miniLeague: MiniLeague }> {
  const call = httpsCallable<{ inviteCode: string }, { ok: true; miniLeague: MiniLeague }>(functions, 'joinMiniLeague');
  return (await call({ inviteCode })).data;
}

export async function leaveMiniLeague(miniLeagueId: string): Promise<{ ok: true }> {
  const call = httpsCallable<{ miniLeagueId: string }, { ok: true }>(functions, 'leaveMiniLeague');
  return (await call({ miniLeagueId })).data;
}

export async function renameMiniLeague(miniLeagueId: string, name: string): Promise<{ ok: true; name: string }> {
  const call = httpsCallable<{ miniLeagueId: string; name: string }, { ok: true; name: string }>(
    functions,
    'renameMiniLeague'
  );
  return (await call({ miniLeagueId, name })).data;
}

export interface UpdateMiniLeagueInput {
  miniLeagueId: string;
  name?: string;
  icon?: string;
  color?: string;
  settings?: { roundReminders?: boolean };
}

export async function updateMiniLeague(input: UpdateMiniLeagueInput): Promise<{ ok: true; miniLeague: MiniLeague }> {
  const call = httpsCallable<UpdateMiniLeagueInput, { ok: true; miniLeague: MiniLeague }>(functions, 'updateMiniLeague');
  return (await call(input)).data;
}

export async function kickMiniLeagueMember(miniLeagueId: string, userId: string): Promise<{ ok: true }> {
  const call = httpsCallable<{ miniLeagueId: string; userId: string }, { ok: true }>(
    functions,
    'kickMiniLeagueMember'
  );
  return (await call({ miniLeagueId, userId })).data;
}

export async function deleteMiniLeague(miniLeagueId: string): Promise<{ ok: true; deleted: true }> {
  const call = httpsCallable<{ miniLeagueId: string }, { ok: true; deleted: true }>(functions, 'deleteMiniLeague');
  return (await call({ miniLeagueId })).data;
}

export interface MiniLeaguePreview {
  miniLeagueId: string;
  name: string;
  icon: string;
  color: string;
  leagueId: string;
  leagueName: string;
  memberCount: number;
  ownerName: string;
  alreadyMember: boolean;
}

export async function previewMiniLeague(inviteCode: string): Promise<{ ok: true; preview: MiniLeaguePreview }> {
  const call = httpsCallable<{ inviteCode: string }, { ok: true; preview: MiniLeaguePreview }>(
    functions,
    'previewMiniLeague'
  );
  return (await call({ inviteCode })).data;
}
